import React                from "react";
import PropTypes            from "prop-types";
import Action               from "Dashboard/Core/Action";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";
import Commons              from "Utils/Commons";

// Components
import WhiteListEdit        from "./WhiteListEdit";

// Dashboard
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Training White List Content
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function WhiteListContent(props) {
    const { type, isCreating, setCreating } = props;
    const { fetch, load } = useList("trainingWhiteList", type);

    const activityID = Commons.useActivityID();

    const data = Store.useState("trainingWhiteList");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("trainingWhiteList");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Open the Create Dialog
    React.useEffect(() => {
        if (isCreating) {
            startAction("CREATE");
        }
    }, [ isCreating ]);

    // Handles the Edit Submit
    const handleEdit = () => {
        handleClose();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        handleClose();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };

    // Handles the Close
    const handleClose = () => {
        setCreating(false);
        endAction();
    };


    // Do the Render
    const elemName = Utils.getValue(list, "trainingWhiteListID", elemID, "memberName");

    return <>
        <Table
            fetch={load}
            sort={sort}
            none="TRAININGS_WHITE_LISTS_NONE_AVAILABLE"
            isLoading={loading}
            hasTabs
        >
            <TableHead>
                <TableHeader field="name"   message="GENERAL_NAME"   isTitle bigMobile />
                <TableHeader field="status" message="GENERAL_STATUS" maxWidth="100" align="center" />
            </TableHead>
            <TableBody>
                {list.map((elem) => <TableRow key={elem.trainingWhiteListID} elemID={elem.trainingWhiteListID}>
                    <TableCell message={elem.name}       />
                    <TableCell message={elem.statusName} textColor={elem.statusColor} />
                </TableRow>)}
            </TableBody>
            <TablePaging total={total} />
            <TableActionList onAction={startAction} canEdit={canEdit}>
                <TableAction action="VIEW"   message="TRAININGS_WHITE_LISTS_VIEW_TITLE"   navigate />
                <TableAction action="EDIT"   message="TRAININGS_WHITE_LISTS_EDIT_TITLE"   />
                <TableAction action="DELETE" message="TRAININGS_WHITE_LISTS_DELETE_TITLE" />
            </TableActionList>
        </Table>

        <WhiteListEdit
            open={action.isVCE}
            elemID={elemID}
            activityID={activityID}
            onSubmit={handleEdit}
            onClose={handleClose}
        />
        <DeleteDialog
            open={action.isDelete}
            title="TRAININGS_WHITE_LISTS_DELETE_TITLE"
            message="TRAININGS_WHITE_LISTS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={handleClose}
        />
    </>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
WhiteListContent.propTypes = {
    type        : PropTypes.string.isRequired,
    isCreating  : PropTypes.bool.isRequired,
    setCreating : PropTypes.func.isRequired,
};

export default WhiteListContent;
